import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { FaClock, FaDollarSign, FaChevronDown, FaChevronUp } from "react-icons/fa";
import "./tourdetails.css";

const TourDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [tour, setTour] = useState(null);
  const [showItinerary, setShowItinerary] = useState(true);
  const [isFixed, setIsFixed] = useState(false);
  const [mainImage, setMainImage] = useState(null);

  useEffect(() => {
    fetch(`https://orangered-hornet-549881.hostingersite.com/api/tours/${id}`)
      .then((res) => res.json())
      .then((result) => {
        setTour(result.data);

        // تعيين أول صورة كـ mainImage
        if (result.data?.images?.length) {
          setMainImage(
            `https://orangered-hornet-549881.hostingersite.com/storage/${result.data.images[0]}`
          );
        }
      })
      .catch((err) => console.error("Error fetching tour:", err));
  }, [id]);

  // تثبيت الكارت في الموبايل
  useEffect(() => {
    const handleScroll = () => {
      if (window.innerWidth <= 768) {
        const section = document.querySelector(".imageGallery");
        if (section) {
          const sectionBottom = section.getBoundingClientRect().bottom;
          setIsFixed(sectionBottom <= 0);
        }
      } else {
        setIsFixed(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (!tour) return <p>Loading...</p>;

  return (
    <section className="tourDetails container">
      <div className="headerRow">
        <h1 className="tourTitle">{tour.title}</h1>
        <div className="tourPrice">
          Start From{" "}
          <span>
            {tour.pricings?.length > 0
              ? `$${Math.min(...tour.pricings.map((p) => parseFloat(p.price_per_person)))}`
              : "N/A"}
          </span>
        </div>
      </div>

      {/* الصور */}
      <div className="imageGallery">
        <div className="mainImage">
          <img src={mainImage} alt={tour.title} />
          <div className="tourMeta">
            <span className="duration_number">
              
{tour.pricings?.length > 0
              ? `$${Math.min(...tour.pricings.map((p) => parseFloat(p.price_per_person)))}`
              : "N/A"}            </span>
            <div className="duration_wrapper">
  <span className="duration_icon">
    <FaClock />
  </span>
  <span className="duration_number">
    {tour.duration_id || "N/A"}
  </span>
</div>

          </div>
        </div>

        <div className="sideImages">
  {Array.isArray(tour.images) && tour.images.length > 0 ? (
    tour.images
      .filter(
        (img) =>
          `https://orangered-hornet-549881.hostingersite.com/storage/${img}` !==
          mainImage
      )
      .map((img, idx) => (
        <img
          key={idx}
          src={`https://orangered-hornet-549881.hostingersite.com/storage/${img}`}
          alt={`image-${idx}`}
          onClick={() =>
            setMainImage(
              `https://orangered-hornet-549881.hostingersite.com/storage/${img}`
            )
          }
          style={{ cursor: "pointer" }}
        />
      ))
  ) : (
    <p>No images available.</p>
  )}

          {/* كارت الحجز */}
          <div className={`bookingCard ${isFixed ? "fixed" : ""}`}>
            <button
              className="bookBtn"
              onClick={() =>
               navigate(`/booking/${tour.id}`, {
  state: {
    tourId: tour.id,
    tourTitle: tour.title,
    tourImage: mainImage, 
    pricings: tour.pricings,
    endDate: tour.days,
  },
                })
              }
            >
              Book Now
            </button>
            {/* <p>Secure your spot with online payment</p> */}
          </div>
        </div>
      </div>

      {/* الوصف */}
      <div className="contentRow">
        <div className="leftContent">
          <section>
            <h2>Description</h2>
            <div dangerouslySetInnerHTML={{ __html: tour.description }} />
          </section>

          <section>
            <h2>Inclusions</h2>
            <div dangerouslySetInnerHTML={{ __html: tour.includes }} />
          </section>

          <section>
            <h2>Exclusions</h2>
            <div dangerouslySetInnerHTML={{ __html: tour.exclusions }} />
          </section>

          <section className="accordion">
            <h2 onClick={() => setShowItinerary(!showItinerary)}>
              Tour Itinerary {showItinerary ? <FaChevronUp /> : <FaChevronDown />}
            </h2>
            {showItinerary && (
              <div
                className="accordionContent"
                dangerouslySetInnerHTML={{ __html: tour.tour_itinerary }}
              />
            )}
          </section>

        {tour.children_policy?.trim() && (
  <section>
    <h2>Children Policy</h2>
    <div dangerouslySetInnerHTML={{ __html: tour.children_policy }} />
  </section>
)}


          <section>
            <h2>Tour Notes</h2>
            <div dangerouslySetInnerHTML={{ __html: tour.tour_notes }} />
          </section>

          {/* الأسعار حسب الجروب */}
          <section className="priceCards">
            {tour.pricings?.map((gp) => (
              <div key={gp.id} className="priceCard">
                <h4>
                  {gp.min_persons} - {gp.max_persons} Persons
                </h4>
                <p>
                  {gp.price_per_person} {gp.currency} / Person
                </p>
              

              </div>
              
            ))}
          </section>
           <section className="priceCards">
  {tour.pricings?.map((gp) => {
    const childPrice = parseFloat(gp.children_price); // convert string → number

    return (
      childPrice > 0 && (
        <div key={gp.id} className="priceCard">
          <h4>Children</h4>
          <p>
            {gp.children_price} {gp.currency} / Child
          </p>
        </div>
      )
    );
  })}
</section>

        </div>
      </div>
    </section>
  );
};

export default TourDetails;
